import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-avisos',
  templateUrl: './avisos.component.html',
  styleUrls: ['./avisos.component.css']
})
export class AvisosComponent implements OnInit {
  @Input() public datAviso;

  swCan = true;
  swNo = true;
  
  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    if (this.datAviso.btcan !== '') {this.swCan = false; }
    if (this.datAviso.btno !== '') {this.swNo = false; }
  }

  saleSI(): void {
     this.activeModal.close('S');
  }
  saleNO() {
    this.activeModal.close('N');
  }
  saleCAN() {
    this.activeModal.close('C');
  }

}
